import { render, staticRenderFns } from "./SheetBlockAssociatedDocumentsItem.vue?vue&type=template&id=0e3b1e9d&scoped=true"
import script from "./SheetBlockAssociatedDocumentsItem.vue?vue&type=script&lang=js"
export * from "./SheetBlockAssociatedDocumentsItem.vue?vue&type=script&lang=js"
import style0 from "./SheetBlockAssociatedDocumentsItem.vue?vue&type=style&index=0&id=0e3b1e9d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e3b1e9d",
  null
  
)

export default component.exports